import { getCookie } from '../cookie';

var getPlatform = function getPlatform() {
  var userAgent = window.navigator.userAgent;
  var rules = [[/\(iPad;/, 'ipad'], [/\(iPhone;/, 'iphone'], [/ Android /, 'android'], [/ Mac OS X /, 'mac'], [/ Windows /, 'windows']];

  for (var i = 0; i < rules.length; i++) {
    var tmp = rules[i];
    var rule = tmp[0];
    var name = tmp[1];
    var rRes = rule.exec(userAgent);

    if (rRes) {
      return name;
    }
  }

  return '';
};
/**
 * 判断当前环境是否为Android
 */


export var isAndroid = function isAndroid() {
  return getPlatform() === 'android';
};
/**
 * 判断当前环境是否为IOS
 */

export var isIOS = function isIOS() {
  return ['ipad', 'iphone'].indexOf(getPlatform()) > -1;
};
/**
 * 判断当前环境是否在端内
 */

export var isInApp = function isInApp() {
  var userAgent = window.navigator.userAgent;
  return userAgent.indexOf('Yoda') > -1;
};
var APP_NAME;

(function (APP_NAME) {
  APP_NAME["PRO"] = "pro";
  APP_NAME["SNACK"] = "snack";
  APP_NAME["ME"] = "me";
})(APP_NAME || (APP_NAME = {}));
/**
 * 获取当前APP名称  默认为Pro
 */


export var getAppName = function getAppName() {
  var userAgent = window.navigator.userAgent;
  var rules = [[/ KWAI\//, APP_NAME.PRO], [/ KWAI\.ME\//, APP_NAME.ME], [/ KWAI_BULLDOG\//, APP_NAME.SNACK]];

  for (var i = 0; i < rules.length; i++) {
    var tmp = rules[i];
    var rule = tmp[0];
    var name = tmp[1];
    var rRes = rule.exec(userAgent);

    if (rRes) {
      return name;
    }
  }

  return APP_NAME.PRO;
};
/**
 * 获取状态栏高度 返回像素单位
 *
 * @returns
 */

export var getStatusBarHeight = function getStatusBarHeight() {
  var userAgent = window.navigator.userAgent;
  var re = /StatusHT\/(\d+)/;
  var match = userAgent.match(re);

  if (!match) {
    return 0;
  }

  return +match[1];
};
/**
 * 获取标题栏高度 返回像素单位
 *
 * @returns
 */

export var getTitleNavHeight = function getTitleNavHeight() {
  var userAgent = window.navigator.userAgent;
  var re = /TitleHT\/(\d+)/;
  var match = userAgent.match(re);

  if (!match) {
    return 0;
  }

  return +match[1];
};
/**
 * 获取当前APP版本号
 *
 * @returns string
 */

export var getAppVersion = function getAppVersion() {
  return getCookie('appver') || '';
};